import { ref } from 'vue';
import ValidPatterns from '../utils/types/ValidPatterns';
import { useTranslation } from './translation';

export function useInputValidation() {
    const { t } = useTranslation();

    const isValid = ref(false);

    function validationReset(): void {
        isValid.value = false;
    }

    return {
        rules: new ValidPatterns(t).getRules(),
        isValid,
        validationReset,
    };
}
